import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
import Select from "react-select"
const EditDiplomeMastere = props => {
  const [nameFr, setNameFr] = useState("")
  const [nameAr, setNameAr] = useState("")
  const [selectCycle, setSelectCycle] = useState("")
  const [cycele, setCycele] = useState([])
  const [loading, setLoading] = useState(false)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  useEffect(async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    const res = await API.post("master/diplome_master/get_by_id", { id }).then(res => {
      setNameAr(res.data.Diplome.name_ar)
      setNameFr(res.data.Diplome.name_fr)
      setSelectCycle(res.data.Diplome.cycle)
      setLoading(true)
    })
    const resCycle = await API.get("master/select_cycle").then(resCycle => {
      setCycele(resCycle.data.Cycles)
    })
  }, [])
  const edit = async () => {
    setLoading(true)
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    if(selectCycle === ""){
      toast.error("⛔ Cycle obligatoire", {
        containerId: "A",
      })
    }else if(nameAr === ""){
      toast.error("⛔ Nom AR obligatoire", {
        containerId: "A",
      })
    }else if(nameFr !== ""){
      API.post("master/diplome_master/edit", {
        id,
        annee_id,
        nom_fr:nameFr,
        nom_ar:nameAr,
        user_id,
        cycle_master_id:selectCycle.value
      }).then(res => {
        if(res.data.errNum ===404 || res.data.errNum ==="404"){
          setLoading(false)
          toast.error("⛔ "+res.data.msg, {
            containerId: "A",
          })
        }else{
          setLoading(true)
          toast.success(" 🔓✔️ Diplôme Mastére modifiée Avec succès", {
            containerId: "A",
          })
          props.history.push("/DiplomeMastere")
        }
      })
    } else {
      toast.error("⛔ Nom FR obligatoire", {
        containerId: "A",
      })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Card>
              <CardBody>
                {loading ? (
                  <AvForm>
                    <Form>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">Cycle :</Label>
                            <Select
                              options={cycele}
                              isSearchable={true}
                              value={selectCycle}
                              onChange={e => setSelectCycle(e)}
                            />
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {"Nom de l'établissement Fr"}
                            </Label>
                            <Input
                              lg="3"
                              type="text"
                              className="form-control"
                              placeholder="Nom de l'établissement Fr"
                              required={true}
                              value={nameFr}
                              onChange={e => setNameFr(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {"Nom de l'établissement Ar"}
                            </Label>
                            <Input
                              lg="3"
                              type="text"
                              className="form-control"
                              placeholder="Nom de l'établissement Ar"
                              required={true}
                              value={nameAr}
                              onChange={e => setNameAr(e.target.value)}
                            />
                          </div>
                        </Col>
                      </Row>

                    </Form>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {" "}
                      <Col lg="6">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                          className="text-center mt-4"
                        >
                          <Button
                            type="button"
                            color="warning"
                            className="btn btn-warning  mb-2 me-2"
                            onClick={() => props.history.push("/EtablissementOrigine")}
                          >
                            {props.t("Annuler")}
                          </Button>
                        </div>
                      </Col>
                      <Col lg="6">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                          className="text-center mt-4"
                        >
                          <button
                            type="button"
                            className="btn btn-primary "
                            onClick={edit}
                          >
                            {props.t("Confirmer")}
                          </button>
                        </div>
                      </Col>
                    </div>
                  </AvForm>
                ) : (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      <Spinner type="grow" className="ms-6" color="primary" />
                    </div>
                    <h4
                      style={{ textAlign: "center", marginTop: "2%" }}
                      className="ms-6"
                    >
                      {" "}
                      {"Chargement"} ...{" "}
                    </h4>
                  </div>
                )}
              </CardBody>
            </Card>
          </Row>
          <ToastContainer
            transition={Slide}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(EditDiplomeMastere)
EditDiplomeMastere.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
